import { SideNav } from "components";
import { HomeWrapper } from "components/CdBalance/style";
import PlansetupButton from "components/UniversalComponents/plansetupButton";
import {
  LargeButton,
  OverlayLoader,
  PageTitle,
} from "components/core";
import {
  RadioListWrapper,
} from "components/core/DocumentCard/styles";
import { sortUserPlanIdsByProductTypeName } from "pages/GradeSetup/schema";
import { ButtonWrapper } from "pages/PlanSelection";
import { WidthLimiter } from "pages/PlanSetup/styles";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import http from "services/httpService";
import { markPlanSetupCompleted } from "utlis/setupUtils";

function PlanSetup() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [flag, setFlag] = useState(false);
  const [masterData, setMasterData] = useState();
  const [loader, setLoader] = useState(true);
  const [products, setProducts] = useState([]);
  const [flex, setFlex] = useState(false);
  const [wellnessSetupState, setWellnessSetupState] = useState(false);
  useEffect(() => {
    let wellnessSetup = false;
    if (state?.wellness) {
      wellnessSetup = true;
      setWellnessSetupState(true);
    }
    getUserplanData(wellnessSetup);
    setLoader(false);
  }, [state?.wellness]);

  console.log({ state, flag });

  const isAddProductFlow = useMemo(() => {
    const params = new URLSearchParams(document.location.search);
    const path = params.get("path");
    const cachedPath = sessionStorage.getItem("setup_path");
    if ((path && path === "add") || cachedPath === "add") {
      sessionStorage.setItem("setup_path", "add");
      return true;
    }
    return false;
  }, []);

  const getUserplanData = async (wellness) => {
    try {
      const { data } = await http.get("business/userplans_data_selected/");
      const keys = Object.keys(data.userplans_data);
      const redirectToUhid = Object.values(data.userplans_data).map(
        (value, index) => {
          const status = value.setup_completed;
          return status;
        }
      );
      const allTrue = redirectToUhid.every((value) => value === true);
      // if (state) {
      //   if (allTrue && data?.dc_collection) {
      //     localStorage.setItem("super_task_id", data?.dc_taskset_id);
      //     if (data.dc_collection === "dc_sheetupload" && data.dc_taskset_id) {
      //       navigate(`/${routes.FLEX_PENDING_STATE}`);
      //     } else if (data.dc_collection === "dc_data" && data.dc_taskset_id) {
      //       navigate(`/${routes.FLEX_DASHBOARD}`);
      //     } else if (data.dc_collection === "dc_sheetupload") {
      //       navigate(`/${routes.EMPLOYEE_DATA_COLLECTION}`);
      //     }
      //     return;
      //   }
      // }
      if (wellness) {
        setFlag(true);
      } else {
        setFlag(allTrue);
      }
      setMasterData(data);
      const sortedKeys = sortUserPlanIdsByProductTypeName(keys, data);
      setProducts(sortedKeys);
      setFlex(data.flex);
      localStorage.setItem("eb_selected_values", JSON.stringify(data));
    } catch (e) {
      console.log(e);
    }
  };
  const submitHandler = () => {
    try {

      const authToken = localStorage.getItem("auth_token");
      const tokenKey = localStorage.getItem("tokenKey");
      const token = localStorage.getItem("token");

      if (authToken && !tokenKey) {
        localStorage.setItem("tokenKey", authToken);

      }
      if (authToken && !token) {
        localStorage.setItem("token", authToken);

      }
      if (tokenKey && !authToken) {
        localStorage.setItem("auth_token", tokenKey);

      }
      if (token && !authToken) {
        localStorage.setItem("auth_token", token);

      }
      if (token && !tokenKey) {
        localStorage.setItem("tokenKey", token);

      }


      localStorage.setItem("flow", "FLEX");
      localStorage.setItem("role", "admin");


      localStorage.removeItem("plan_setup_pending");
      localStorage.removeItem("plan_setup_from_scratch");


      markPlanSetupCompleted();




      navigate("/v1/");
    } catch (error) {
      console.error("❌ Error in submitHandler:", error);

    }
  };
  return (
    <>
      {loader ? (
        <OverlayLoader />
      ) : (
        <section>
          <SideNav />
          <HomeWrapper>
            <PageTitle title="Plan Setup" />
            <WidthLimiter>
              <RadioListWrapper>
                {products.map((value, index) => {
                  const productDetail = masterData.userplans_data[value];
                  return (
                    <div key={index}>
                      <PlansetupButton
                        key={index}
                        products={products}
                        wellnessSetupState={wellnessSetupState}
                        isAddProductFlow={isAddProductFlow}
                        flex={flex}
                        details={productDetail}
                        userplan={value}
                      />
                    </div>
                  );
                })}
              </RadioListWrapper>
              <ButtonWrapper>
                {flag && (
                  <LargeButton
                    onClick={submitHandler}
                    label="Save & Next"
                    style={{ padding: "18px 0px", width: '932px' }}
                  />
                )}
              </ButtonWrapper>
            </WidthLimiter>
          </HomeWrapper>
        </section>
      )}
    </>
  );
}

export default PlanSetup;
